export default __webpack_public_path__ + "static/media/bg.bc1c5179.png";